export default __webpack_public_path__ + "assets/hand-plant.as-path.352012c3.svg";